import React, { PropTypes } from 'react';
import PlayerList from './PlayerList';
import { List } from 'immutable';
import Header from '../../ClubCmsHeader';
import ClubCmsAddHeader from '../../ClubCmsAddHeader';
import {CMSContentType} from '../../../../api/club-cms/CMSType';

class PlayerListContent extends React.Component {
  static propTypes = {
    node: PropTypes.object,
    lazyLoadPlayers: PropTypes.func.isRequired,
    addHeaderTwo: PropTypes.func.isRequired,
    onUpdateContent: PropTypes.func.isRequired,
    updateHeaderOneLabel: PropTypes.func.isRequired,
    updateHeaderTwoLabel: PropTypes.func.isRequired,
    removeHeaderOne: PropTypes.func.isRequired,
    removeHeaderTwo: PropTypes.func.isRequired,
    removeContent: PropTypes.func.isRequired,
    players: PropTypes.arrayOf(PropTypes.object),
    playersLoading: PropTypes.bool,
    addHeaderTwoContent: PropTypes.func.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  componentWillMount() {
    this.props.lazyLoadPlayers();
  }

  getStyle() {
    return {
      flexContainerStyle: {
        height: 6*100,
        border: 'solid 1px black',
        display: 'flex',
        flexDirection: 'row'
      },
      flexContentStyle: {
        height: '100%',
        border: 'solid 1px black',
        flexBasis: '50%',
        flexGrow: 1,
        overflowY: 'auto'
      }
    };
  }

  _getContentType() {
    return this.props.node.children.first()
      .children.first()
      .type;
  }

  _addItem(playerId, listContent) {
    const { players, onUpdateContent } = this.props;
    let currentPlayer = players.find((player) => player.id === playerId);
    if (listContent && currentPlayer) {
      onUpdateContent(listContent.addPlayer(currentPlayer));
    }
  }

  _removeItem(playerId, listContent) {
    const { players, onUpdateContent } = this.props;
    let currentPlayer = players.find((player) => player.id === playerId);

    if (listContent) {
      onUpdateContent(listContent.removePlayer(currentPlayer));
    }
  }

  _moveItem(playerId, listContent, playerListContent) {
    if (listContent && !listContent.equals(playerListContent)) {
      this._removeItem(playerId, listContent);
      this._addItem(playerId, playerListContent);
    } else if (!listContent) {
      this._addItem(playerId, playerListContent);
    }
  }

  _changeLabel(label, content) {
    const { onUpdateContent } = this.props;
    onUpdateContent(content.setLabel(label));
  }


  _getUnusedPlayers() {
    let { players, node } = this.props;

    const usedPlayers = node.children
      .map(
        headerTwo => headerTwo.children
          .map(content => content.items)
      )
      .flatten();

    const usedPlayerIds = usedPlayers.map(player => player.id).toArray();

    return List(players).filterNot(player => usedPlayerIds.indexOf(player.id) !== -1).toArray();
  }

  _getPlayersByItems(playerListContent) {
    return this.props.players.filter(player =>
      playerListContent.items.toArray().some(playerContent =>
        playerContent.player_id === player.id
      )
    )
  }

  render() {
    let {
      node,
      playersLoading,
      addHeaderTwo,
      addHeaderTwoContent,
      removeContent,
      updateHeaderTwoLabel,
      removeHeaderTwo
    } = this.props;
    let { flexContainerStyle, flexContentStyle } = this.getStyle();

    const {
      baseTheme: {palette: { primary1Color }}
    } = this.context.muiTheme;
    return (
      <div style={flexContainerStyle}>
        <div style={flexContentStyle}>
          {node.children.map(
            (headerTwo) => (
              <Header
                key={headerTwo.label}
                label={headerTwo.label} color={primary1Color}
                onChangeLabel={(label) => updateHeaderTwoLabel(headerTwo, label)}
                canDelete={node.children.size > 1}
                remove={() => removeHeaderTwo(headerTwo)}>
              {headerTwo.children.map(
                playerListContent => (
                  <Header
                    key={playerListContent._id}
                    label={playerListContent.label}
                    canDelete={headerTwo.children.size > 1}
                    onChangeLabel={(label) => this._changeLabel(label, playerListContent)}
                    remove={() => removeContent(playerListContent)}>
                      <PlayerList
                        players={this._getPlayersByItems(playerListContent)}
                        listContent={playerListContent}
                        onDropPlayer={(playerId, listContent) =>
                          this._moveItem(playerId, listContent, playerListContent)
                        }
                      />
                  </Header>
                )
              )}
                <ClubCmsAddHeader
                  label="Add Subtitle"
                  onClick={() => addHeaderTwoContent(headerTwo, CMSContentType.playerList)}
                />
              </Header>
            )
          )}
          <ClubCmsAddHeader
            label="Add Title"
            onClick={() => addHeaderTwo(this._getContentType())}
            color={primary1Color}
          />
        </div>
        <div style={flexContentStyle}>
          {!playersLoading
            ? (
              <PlayerList
                players={this._getUnusedPlayers()}
                onDropPlayer={(playerId, listContent) => this._removeItem(playerId, listContent)}
              />
            ) : (
              <div>Loading...</div>
            )
          }
        </div>
      </div>
    );
  }
}

// export default DragDropContext(HTML5Backend)(PlayerListContent);
export default PlayerListContent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/PlayerListContent/PlayerListContent.js